export default (name, styles) => {
  if (!styles || !styles?.length) return "";

  return styles.map(style => ` ${name}:${style} `);
};
